<template>
  <v-dialog v-model="show2" fullscreen :transition=false>
    <v-card>
      <v-container fill-height class="bootstrap-container">
        <v-layout row fill-height align-center>
          <v-flex>
            <transition name="fade" mode="in-out"
              @enter="animationDone"
            >
              <div class="bootstrap-step" v-if="step === 1" key="s1">
                <img src="../../assets/images/bootstrap-logo-ltu.png" >
              </div>
              <div class="bootstrap-step" v-else-if="step === 2" key="s2">
                <img src="../../assets/images/bootstrap-logo-otarc.png" >
              </div>
              <div class="bootstrap-step" v-else-if="step === 3" key="s3">
                <img src="../../assets/images/bootstrap-logo-uni-of-salamanca.png" >
              </div>
              <div class="bootstrap-step" v-else-if="step === 4" key="s4">
                <img src="../../assets/images/bootstrap-logo-salesforce.png" >
              </div>
              <div class="bootstrap-step" v-else-if="step === 5" key="s5">
                &nbsp;
              </div>
              <div class="bootstrap-step" v-else-if="step === 6" key="s6">
                Loading...
              </div>
              <div class="bootstrap-step" v-else key="empty">
                &nbsp;
              </div>
            </transition>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-btn ref="fab" color="primary" dark fab fixed bottom
      v-if="appInit" @click.stop="closeAndSetAppReady(true)" right>
      <v-icon>skip_next</v-icon>
    </v-btn>

  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { UPDATE_APP_READY } from '@/store/mutation-types'

export default {
  name: 'BootstrapDialog',
  computed: {
    ...mapState([
      'appInit'
    ])
  },
  data () {
    return {
      show2: false,
      step: 1,
      maxStep: 6
    }
  },
  methods: {
    closeDialog () {
      this.show2 = false
    },
    animationDone () {
      if (this.step >= this.maxStep) {
        return
      }

      setTimeout(() => {
        // no need to show last step if initialization is done
        if (this.readyToClose()) {
          this.closeAndSetAppReady()
          return
        }
        this.step++
      }, 3000)
    },
    readyToClose () {
      return this.appInit && this.step >= this.maxStep - 1
    },
    closeAndSetAppReady (force) {
      this.updateAppReady(true)

      const delayTime = force ? 0 : 750

      setTimeout(() => {
        this.show2 = false

        setTimeout(() => {
          const domHTML = document.getElementsByTagName('html')[0]
          domHTML.classList.remove('hide-overflow')
        }, 250)
      }, delayTime)
    },
    ...mapMutations({
      updateAppReady: UPDATE_APP_READY
    })
  },
  mounted () {
    const domHTML = document.getElementsByTagName('html')[0]
    domHTML.classList.add('hide-overflow')
    this.animationDone()
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (val) {
      this.show2 = val
    },
    show2 (val) {
      if (this.show2 !== this.show) {
        this.$emit('update:show', this.show2)
      }
    },
    step (val) {
      if (this.readyToClose()) {
        this.closeAndSetAppReady()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bootstrap-container {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}

.bootstrap-step {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  img {
    margin: auto;
    max-width: 350px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/BootstrapDialog.vue